import { componentStyles } from "./live-board-tab-component.scss";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import FlexibleCardGridComponent from "segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component";

const LiveBoardTabComponent = (props) => {
  const { description, gridItems } = props;
  return (
    <div className="live-board-tab-wrapper">
      <div className="description-wrapper">
        <Paragraph body={description} />
      </div>
      {gridItems?.map((item) => (
        <FlexibleCardGridComponent gridItems={item} />
      ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default LiveBoardTabComponent;
